import React from 'react'
import { useDesktop } from 'use/media'
import useMobile from 'ui/Datatable/mobile'

// Components
import Col from 'ui/Col'
import LoginForm from 'components/Auth/LoginForm'
import LoginBanner from 'ui/LoginBanner'
import Row from 'ui/Row'
import Box from 'ui/Box'

export default function PageLogin() {
  const isDesktop = useDesktop()
  const isMobile = useMobile()

  return (
    <div
      style={{
        height: isDesktop ? '100vh' : 'auto',
        background: '#F4FBFF',
        padding: isMobile ? 0 : 40,
      }}
      className="x-login-page d-flex align-items-center justify-content-center"
    >
      <Box
        shadow={!isMobile}
        style={{ padding: isMobile ? '0' : '60px 10px', width: '100%' }}
      >
        <Row noGutters style={{ height: 'auto' }}>
          <Col
            sm={{ span: 12, vcenter: true }}
            md={{ span: 7, vcenter: true }}
            lg={{ span: 7, vcenter: true }}
          >
            <LoginBanner></LoginBanner>
          </Col>
          <Col
            sm={{ span: 12, vcenter: true }}
            md={{ span: 5, vcenter: true }}
            lg={{ span: 5, vcenter: true }}
            xl={{ span: 4, vcenter: true }}
          >
            <LoginForm></LoginForm>
          </Col>
        </Row>
      </Box>
    </div>
  )
}
